const mainNav = [
    {
        name: "tv",
        link: "/tv",
        query: null,
    },
    {
        name: "movies",
        link: "/movies",
        query: {
            season: 0,
            cgid: 260,
        },
    },
    {
        name: "serials",
        link: "/serials",
        query: {
            season: 1,
            cgid: 260,
        },
    },
    {
        name: "kids",
        link: "/kids",
        query: {
            genre: "209,161,104,249,241",
            cgid: 260,
        },
    },
    {
        name: "uzbList",
        link: "/uzb",
    },
];

const devices = [
    {
        name: "IOS",
        link: "",
        externalLink: "https://apps.apple.com/app/tvcom-uz/id6479690034",
        query: null
    },
    {
        name: "Android/Android TV",
        link: "android",
        query: null
    },
    {
        name: "LG Smart TV",
        link: "Lg",
        query: null
    },
    {
        name: "Samsung Smart TV",
        link: "Samsung",
        query: null
    }
];

const help = [
    {
        name: "message.help",
        link: "Pay",
        query: null
    },
    {
        name: "message.tariffs",
        link: "cabinet",
        query: null
    },
    {
        name: "message.questionanswer",
        link: "answers",
        query: null
    }
];

const aboutUs = [
    {
        name: "message.news",
        link: "blogs",
        query: null
    },
    {
        name: "message.aboutCompany",
        link: "about",
        query: null
    },
    {
        name: "message.workin",
        link: "job",
        query: null
    }
];

export const routes = {
    mainNav,
    devices,
    help,
    aboutUs
};
